import * as Yup from 'yup'

export const emailSchema = Yup.string()
  .email('Invalid email')
  .required('Email Required')

export const usernameSchema = Yup.string()
  .required('Username Required')
  .matches(/^(?!\s+)/, 'Must not contain leading whitespace characters')
  .matches(/^(?!.*\s+$)/, 'Must not contain trailing whitespace characters')
  .matches(/[\p{L}\p{M}\p{S}\p{N}\p{P}]+/u, 'Has an invalid format')
  .min(3, 'Must be at least 3 characters long.')
  .max(12, 'Username is too long. There should be 12 chars maximum.')

export const passwordSchema = Yup.string()
  .required('No password provided.')
  .matches(/^(?!\s+)/, 'Must not contain leading whitespace characters')
  .matches(/^(?!.*\s+$)/, 'Must not contain trailing whitespace characters')
  .matches(/^(?=.*[0-9])/, 'Must contain at least 1 number')
  .matches(/^(?=.*[a-z])/, 'Must contain at least 1 lowercase character')
  .matches(/^(?=.*[A-Z])/, 'Must contain at least 1 uppercase character')
  .matches(
    /^(?=.*[\^$*.[\]{}()?"!@#%&/\\,><':;|_~`=+-])/,
    'Must contain at least 1 special character'
  )
  .min(8, 'Must be at least 8 characters long.')
  .max(256, 'Must be at most 256 characters long.')

export const acceptTermsSchema = Yup.boolean()
  .required('You must accept the terms and conditions')
  .oneOf([true], 'You must accept the terms and conditions')

export const usernameOrEmailSchema = Yup.string()
  .required('Username Required')
  .test('username', 'Invalid username or email', (value) => {
    const emailRegex = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/
    const usernameRegex = /^[a-zA-Z0-9]+([_ -]?[a-zA-Z0-9])*$/
    return emailRegex.test(value) || usernameRegex.test(value)
  })

export const codeSchema = Yup.array().of(
  Yup.string()
    .required('Required')
    .length(1, 'Invalid code')
    .matches(/^[0-9]$/, 'Must be a number')
)

export const errors = {
  USER_NOT_FOUND: 'UserNotFoundException',
  INCORRECT_PASSWORD: 'NotAuthorizedException',
  USER_NOT_CONFIRMED: 'UserNotConfirmedException',
  MFA_REQUIRED: 'MFA Required',
  EMAIL_ALREADY_EXISTS: 'PreSignUp failed with error Email already exists. ',
  USER_ALREADY_EXISTS: 'User already exists',
}
